import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import ProductionActivityRowCard from "./ProductionActivityCard";
import { onProductionActivity } from "common/signalR";

interface Props {
  productionId: number
  config: server.dto.ActivityPanelConfig
}

const ProductionActivityPanel = (props: Props) => {
  const { productionId, config } = props;

  return <ActivityPanel<server.dto.TourActivity>
    activityKey="production"
    itemId={productionId}
    config={config}
    fetchActivities={(page, perPage) => window.CoreApi.Production.ListActivity({ page, perPage, itemId: productionId })}
    renderActivity={(activity) => <ProductionActivityRowCard key={activity.activityId} activity={activity} />}
    onActivityRegisterFn={onProductionActivity}
    onActivity={() => ({ refreshActivities: true })}
  />;
};

export default ProductionActivityPanel;
